import React, { memo, useMemo } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import RegionMap from '../Common/RegionMap';
import "../../../../assets/scss/shape-popup.scss";
import { StorageLocation } from '../../map/geo/StorageLocation';
import classNames from 'classnames';
const CardBody = ({ index, selectedIndex, offloadDetails, isRequesting }) => {
	const settings = useSelector((state) => state.user.settings);

	const staticOptions = useMemo(() => ({
		fillColor: "#baf5d593",
		fillOpacity: 1,
		strokeColor: "#ffff",
		strokeOpacity: 1,
		strokeWeight: 2,
		clickable: false,
		draggable: false,
		editable: false,
		geodesic: false,
		zIndex: 3,
		mapTypeId: 'satellite',
	}), []);

	const hasShapes = offloadDetails && offloadDetails.shapes && offloadDetails.shapes.length > 0;
	const shape = hasShapes ? offloadDetails.shapes[0] : {};

	return (
		<Card.Body className={classNames('field-map-body', { show: selectedIndex.includes(index), hide: !selectedIndex.includes(index) })}>
			<Row className='fieldmap_body_content justify-content-between mx-0'>
				<Col className='col-7 px-0 field_map_container'>
					<RegionMap
						location={offloadDetails.location}
						properties={staticOptions}
						newWorkedPoints={null}
						mapHeight="100%"
						width="95%"
						selectedEG="selectedEG"
					/>
				</Col>
				<Col className="harvest_summary col-5 ml-0 px-0">
					{/* <h5>Loads</h5>
						<ul>
								<li><span>Capacity: </span> 0 sacks</li>
								<li><span>Projected Total: </span> 0 loads</li>
								<li><span>Projected Remaining: </span> 0 loads</li>
						</ul> */}
					<StorageLocation
						geoRegionShapeId={shape.geo_shape_object_uuid || null}
						shapeId={shape.geo_shape_uuid || null}
						shapeName={shape.geo_shape_name || null}
						cropName={null}
						isRequesting={isRequesting}
						totalArea={null}
						settings={settings}
						isCardBody={true}
					/>
				</Col>
			</Row>
		</Card.Body>
	);
};

export default memo(CardBody);
